const styles = theme => ({
  root: {
    display: 'inline-block',
    opacity: 0,
    willChange: 'opacity'
  }
});

export { styles };
